import React, { useContext, useEffect, useRef, useState } from "react";

import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Table from "react-bootstrap/Table";



import IPreAlertaUnitizador from "../interfaces/IPreAlertaUnitizador";
import {
  ATRIBUTOS_FILTRO_RELATORIO_UNITIZADORES_CSV,
  ATRIBUTOS_FILTRO_TELA_UNITIZADORES,
  BRANCO,
  CEPZERO,
  SINTETICO,
  UNITIZADORES,
  VAZIO,
  VENCER,
  VENCIDO,
  VERDE,
  VERMELHO
} from "../utils/Constants";
import telaTabelaCabecalho from './relatorios/TelaTabelaCabecalho';
import comparativoPdf from './relatorios/sinteticoPdf';

import { Justify, SortDown, SortUp } from "react-bootstrap-icons";

import { Link, useNavigate } from "react-router-dom";
import EctCaixasObjeto from '../../../assets/img/objeto.svg';
import FiltrarExportar from "../../../components/FiltrarExportar";
import PaginationComponent from "../../../components/Pagination";
import { api } from "../../../services/Api";
import { AuthContext } from '../../../store/AuthContext';
import { dataAtualFormatada, dateTimeStringToISOFormat, montaMenssagemRetornoErroPromiseAllSettled } from "../../../util/FuncoesComuns";
import { AlertaExpedicaoContext } from "../contextsAlerta/AlertaExpedicao";
import ITable from "../interfaces/ITable";
import { aplicarFiltro } from "../utils/Filtros";
import { Mensagem } from "../utils/mensagem";
import "./index.css";

interface Props {
  linkClicado: (key: any) => void;
  isLinkClicado: (key: any) => boolean;
}

const ListaUnitizadorUnidadeData = ({ linkClicado, isLinkClicado }: Props) => {

  const navigate = useNavigate()
  const { user, setErro } = useContext(AuthContext);
  const divTable = useRef<null | HTMLInputElement>(null);
  const [, setMensagem] = useState<Mensagem>({ delay: 5000, tipo: '', texto: '', url: '/alerta-expedicao' });
  const [columns, setColumns] = useState<ITable[]>([]);
  const [filtro, setFiltro] = useState<string>('');
  const [linhaClicada, setLinhaClicada] = useState("")
  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");
  const [listaUnitizadorUnidadeData, setListaUnitizadorUnidadeData] = useState<IPreAlertaUnitizador[]>([]);
  const [listaUnitizadorUnidadeDataFiltrada, setListaUnitizadorUnidadeDataFiltrada] = useState<IPreAlertaUnitizador[]>([]);
  const [, setShowToast] = useState<boolean>(false);
  const [valoresPaginacao, setValoresPaginacao] = useState<any>({});
  const [currentPage, setCurrentPage] = useState(0);
  const [numUnitizadorConsultar, setNumUnitizadorConsultar] = useState<string>('');

  const {
    key, setKey,
    setKeyTabTipoCarga,
    configuracao, setConfiguracao,
    setShowSpinner,
    dataSelecionada, setDataSelecionada,
    setIPreAlertaUnitizador,
    setCodSroUnidadeOrigem,
  } = useContext(AlertaExpedicaoContext)

  useEffect(() => {
    setCurrentPage(() => 0);
    setDataSelecionada(()=>'1900-01-01');
    setShowSpinner(()=>true);
    setCodSroUnidadeOrigem(()=>CEPZERO)
    return () => {
      setNumUnitizadorConsultar(()=>'');
      setCodSroUnidadeOrigem(()=>CEPZERO)
      setCurrentPage(() => 0);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(() => {
    setShowSpinner(()=>true)
    if (key === UNITIZADORES) {
      setColumns(telaTabelaCabecalho(SINTETICO, 'unitizadores'));
      setShowSpinner(()=>true);
      consultarUnitizadoresUnidadeDataSelecionada();
    }

    if (key === 'resumo') setDataSelecionada(()=>'1900-01-01');

    return () => {
      setShowSpinner(()=>false)
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  },[key,currentPage])

  const setIPreAlertaUnitizadorIndex = (event: React.MouseEvent<HTMLElement>, item: IPreAlertaUnitizador, linhaClicada: number) => {
    event.preventDefault()
    setIPreAlertaUnitizador(item);
    setConfiguracao({ ...configuracao, rowUnitClicada: linhaClicada })
    setKey('unitizador')
  }

  const setFiltroInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    setFiltro(event.target.value)
    if (event.target.value && event.target.value !== '' && event.target.value.length > 1) {
      let value = event.target.value.trim().toLowerCase();
      let dataHoraAtual = dataAtualFormatada('dia','/').concat(' 00:00:00');
      //prazo máximo de entrega a vencer
      if(VERDE.includes(value) || value === VERDE || VENCER.includes(value)  || value === VENCER) {
        let res= listaUnitizadorUnidadeData.filter((linha) => {
          return linha.dataMaximaPrazoMinimo && new Date(dateTimeStringToISOFormat(linha.dataMaximaPrazoMinimo)).getTime() >= new Date(dateTimeStringToISOFormat(dataHoraAtual)).getTime();
        });
        setListaUnitizadorUnidadeDataFiltrada(res)
      //Prazo máximo de entrega vencido
      } else if (VERMELHO.includes(value) || value === VERMELHO  || VENCIDO.includes(value) || value === VENCIDO) {
        let res= listaUnitizadorUnidadeData.filter((linha) => {
          return linha.dataMaximaPrazoMinimo && new Date(dateTimeStringToISOFormat(linha.dataMaximaPrazoMinimo)).getTime() < new Date(dateTimeStringToISOFormat(dataHoraAtual)).getTime();
        });
        setListaUnitizadorUnidadeDataFiltrada(res)
      //Prazo máximo de entrega em branco, vazio, não calculado
      } else if(BRANCO.includes(value) || value === BRANCO || VAZIO.includes(value) || value === VAZIO) {
          let res= listaUnitizadorUnidadeData.filter((linha) => {
              return !linha.dataMaximaPrazoMinimo;
          });
          setListaUnitizadorUnidadeDataFiltrada(res)
      }else{
        let res: any = aplicarFiltro(listaUnitizadorUnidadeData, ATRIBUTOS_FILTRO_TELA_UNITIZADORES, event.target.value);
        setListaUnitizadorUnidadeDataFiltrada(res)
      }
    } else {
      setListaUnitizadorUnidadeDataFiltrada(listaUnitizadorUnidadeData)
    }
  }

  const consultarUnitizadoresUnidadeDataSelecionada = () => {

      (async function () {

        setShowSpinner(() => true);
        const data = dataSelecionada && dataSelecionada.includes('/') ? dataSelecionada.split('/').reverse().join('-') : !dataSelecionada ? "1900-01-01" : dataSelecionada;
        const codSroOrigem = numUnitizadorConsultar && numUnitizadorConsultar.length === 8 ? numUnitizadorConsultar : CEPZERO;
        const [resLista] = await Promise.allSettled([api.get(`/v1/expedicoes-pre-alertas/unitizadores?codSroDestino=${user?.unidadeSro?.codigoSro}&codSroOrigemExpedicao=${codSroOrigem}&dataExpedicao=${data}&page=${currentPage < 0 ? 0 : currentPage}&size=500`)]);

        if (resLista.status === 'fulfilled') {
          const res = await resLista.value.data;
          const dados = res && res.content ? res.content : [];

          setListaUnitizadorUnidadeData(()=>dados);
          setListaUnitizadorUnidadeDataFiltrada(()=>dados);
          setValoresPaginacao(res);

          setMensagem({ delay: 2000, tipo: 'info', texto: `Ok : Consulta realizada com sucesso.`, url: '/alerta-expedicao' });
          setShowSpinner(()=>false);
          setShowToast(true);
        } else if (resLista.status === 'rejected') {
          setErro({ delay: 5000, tipo: 'danger', texto: montaMenssagemRetornoErroPromiseAllSettled(resLista,'Erro ao chamar /v1/expedicoes-pre-alertas/unitizadores?codSroDestino={codigoSro}&dataExpedicao={data} - Rejeitado.'), url: '/erro' });
          setShowSpinner(()=>false);
          navigate('/erro')
        } else {
          setErro({ delay: 5000, tipo: 'warning', texto: `Alerta : Erro ao chamar /v1/expedicoes-pre-alertas/unitizadores?codSroDestino={codigoSro}&dataExpedicao={data} - Outros.`, url: '/erro' });
          setShowSpinner(()=>false);
          navigate('/erro')
        }

      })();

  }


  const handleSortingChange = (accessor: string) => {
    const sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
    handleSorting(accessor, sortOrder);
  }

  const execute = (e: any, data: any, i: number, linha: string) => {
    setIPreAlertaUnitizadorIndex(e, data, i);
    setKeyTabTipoCarga(() => data && data.tipoCarga === 'NURG' ? 'nurg' : 'urg');
    setLinhaClicada(linha);
    setKey(()=>'objetos');
  }

  const handleSorting = (sortField: string | number, sortOrder: string) => {
      if (sortField) {
      const sorted = [...listaUnitizadorUnidadeDataFiltrada].sort((a, b) => {
        if ((a as Record<string, any>)[sortField] === null) return 1;
        if ((b as Record<string, any>)[sortField] === null) return -1;
        if ((a as Record<string, any>)[sortField] === null && (b as Record<string, any>)[sortField] === null) return 0;

        //Caso específico de data no formato dd/mm/aaaa faz este sort
        if(sortField === 'dataMaximaPrazoMinimo') {
          const data01011900 = '01/01/1900 00:00:00';
          let dataA=(a as Record<string, any>)[sortField];
          let dataB=(b as Record<string, any>)[sortField];
          dataA = dataA ? dataA : data01011900;
          dataB = dataB ? dataB : data01011900;
          return sortOrder === "asc" ? new Date(dateTimeStringToISOFormat(dataA.toString())).getTime() - new Date(dateTimeStringToISOFormat(dataB.toString())).getTime() : new Date(dateTimeStringToISOFormat(dataB.toString())).getTime() - new Date(dateTimeStringToISOFormat(dataA.toString())).getTime();
        }else{
          return (
            (a as Record<string, any>)[sortField].toString().localeCompare((b as Record<string, any>)[sortField].toString(), "pt-BR", {
              numeric: true,
            }) * (sortOrder === "asc" ? 1 : -1)
          );
        }
      });

      setListaUnitizadorUnidadeDataFiltrada(sorted);
    }
  };

  const montarCabecalho = () => {

    let cab = columns.map(({ label, accessor, sortable, className }) => {
      const cl = sortable ? sortField === accessor && order === "asc"
        ? <SortUp className="icon-table-sortable" />
        : sortField === accessor && order === "desc"
          ? <SortDown className="icon-table-sortable" />
          : <Justify className="icon-table-sortable" />
        : "";

      return (
        <th
          key={accessor}
          className={`${sortable ? `${className} cursor-pointer` : `${className}`}`}
          onClick={sortable ? () => handleSortingChange(accessor) : undefined}
        >
          {cl}
          {label !== 'checkbox-cabecalho' ? label : <Form.Check type="checkbox" disabled={!listaUnitizadorUnidadeDataFiltrada || listaUnitizadorUnidadeDataFiltrada.length === 0} />}
        </th>
      );
    });
    return cab;
  }

  const returnCustomizadaTd = (accessor: string, classNameData: string,i:number, data: any) => {

    let dataHoraAtual = dataAtualFormatada('dia','/').concat(' 00:00:00');
    let dataMaximaPrazoMinimo = data.dataMaximaPrazoMinimo ? data.dataMaximaPrazoMinimo.split(' ')[0] : data.dataMaximaPrazoMinimo;
    if (accessor === 'objeto') return <td id={accessor} key={accessor} className='text-center'><a onClick={(e) => e.stopPropagation()} title={`Clique para rastrear o objeto ${data.objeto}`} href={`${process.env.REACT_APP_URL_PAGE_RASTREAMENTO}?objetos=${data.objeto}`} target="_blank" rel="noopener noreferrer"><strong>{data.objeto}</strong></a></td>
    if (accessor === 'numUnitizador') return <td id={accessor} key={accessor} className='text-center'><a className={isLinkClicado(`U${data.numUnitizador}`) ? 'text-center visited' : 'text-center'} onClick={(e) => linkClicado(`U${data.numUnitizador}`)} title={`Clique para rastrear o unitizador ${data.numUnitizador}`} href={`${process.env.REACT_APP_URL_PAGE_RASTREAMENTO}?objetos=${data.numUnitizador}`} target="_blank" rel="noopener noreferrer"><strong>{data.numUnitizador}</strong></a></td>
    if (accessor === 'dataMaximaPrazoMinimo') return <td key={accessor} id={accessor} className={data.dataMaximaPrazoMinimo && new Date(dateTimeStringToISOFormat(data.dataMaximaPrazoMinimo)).getTime() >= new Date(dateTimeStringToISOFormat(dataHoraAtual)).getTime() ? 'text-center text-success' : 'text-center text-danger'}>{dataMaximaPrazoMinimo}</td>

    return <td id={accessor} key={accessor} className={!classNameData || classNameData === "" ? "" : classNameData}>
    <Link to="#" id="btn-bottom-voltar"
      className={data.dataExpedicao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', '') !== linhaClicada ? 'me-2 text-secondary' : 'me-2 text-success'}
      title={`Clique para acessar a aba Objetos de tratamento dos pré-alertas pendentes.`}
      role="button" onClick={(e) => execute(e, data, i, data.dataExpedicao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', ''))}>
      <img className="icon-pre-alerta" src={EctCaixasObjeto} alt={`Clique para acessar a aba Objetos de tratamento dos pré-alertas pendentes.`}/>
    </Link>
  </td>

  }

  return (

    <>

      <FiltrarExportar
      filtro={filtro}
      lista={listaUnitizadorUnidadeDataFiltrada}
      keyTabLocal={key}
      numUnitizadorOuObjetoConsultar={numUnitizadorConsultar}
      setNumUnitizadorOuObjetoConsultar={setNumUnitizadorConsultar}
      setFiltroInput={setFiltroInput}
      consultarCodSroOrigemOuUnitizadorOuObjeto={consultarUnitizadoresUnidadeDataSelecionada}
      downloadAnaliticoPdf={comparativoPdf}
      header_csv={ATRIBUTOS_FILTRO_RELATORIO_UNITIZADORES_CSV}
      placeholderCodSroUnitizadorObjeto={"Código SRO"}
      setCurrentPage={setCurrentPage}
      />

      <Row className="mx-0">
          <Col sm={10} className="mt-0 pb-0 gap-5">

            <PaginationComponent
              itemsCount={valoresPaginacao && valoresPaginacao.totalElements ? valoresPaginacao.totalElements : 0}
              itemsPerPage={500}
              totalPages={valoresPaginacao && valoresPaginacao.totalPages ? valoresPaginacao.totalPages : 0}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              alwaysShown={false}
            />

          </Col>
          <Col sm={2} className="mt-0 pt-0 pb-0 gap-5 text-center align-middle fs-5 border rounded">
          {valoresPaginacao && valoresPaginacao.totalElements && valoresPaginacao.totalElements > 0 && listaUnitizadorUnidadeDataFiltrada ?
              <React.Fragment>
                <h5 className="pt-1">{`Mostrando ${listaUnitizadorUnidadeDataFiltrada.length} ite${listaUnitizadorUnidadeDataFiltrada.length > 1 ? 'ns' : 'm'} de ${valoresPaginacao.totalElements}.`}</h5>

              </React.Fragment>
              :

              <React.Fragment />

          }
          </Col>
      </Row>

      <div ref={divTable} className="mb-2 mt-1">
        <Table id="tabela-lista-expedicao-pendente" responsive striped className="scroll mb-0">
          <thead>
            <tr>
              {montarCabecalho()}
            </tr>
          </thead>
          {listaUnitizadorUnidadeDataFiltrada && listaUnitizadorUnidadeDataFiltrada.length > 0 ?

            (<tbody>
              {listaUnitizadorUnidadeDataFiltrada.map((data: any, index: number) => {
                let i = ++index;
                if ('objeto' in data && !data?.acao) data.acao = { selecionado: false, motivo: 0 }

                return (

                  <tr id={String(index)} onClick={(e) => execute(e, data, i, data.dataExpedicao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', ''))} key={index} className={data.dataExpedicao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', '') !== linhaClicada ? 'cursor-pointer' : 'cursor-pointer row-selecionada'}>
                    {columns.map(({ accessor, classNameData }) => {

                      const tData = accessor !== 'numUnitizador' && accessor !== 'objeto'  && accessor !== 'dataMaximaPrazoMinimo' && ((data as Record<string, any>)[accessor] || (data as Record<string, any>)[accessor] >= 0) ? (data as Record<string, any>)[accessor] : "link";

                      return tData !== "link" ? <td key={accessor} id={accessor} className={!classNameData || classNameData === "" ? "" : classNameData}>{tData}</td>
                        :

                        returnCustomizadaTd(accessor, classNameData,i, data);

                    })}
                  </tr>
                );
              })}
            </tbody>)

            :

            (<tbody><tr><td key={new Date().toLocaleTimeString()} colSpan={columns.length} className="text-center"><strong className="text-center">Não encontrou dados.</strong></td></tr></tbody>)
          }

        </Table>
      </div>

      <Row className="mb-2 ms-0 me-0 ps-1 pb-4">
          <Col sm={10} className="mt-0 pb-0 gap-5">

            <PaginationComponent
              itemsCount={valoresPaginacao && valoresPaginacao.totalElements ? valoresPaginacao.totalElements : 0}
              itemsPerPage={2000}
              totalPages={valoresPaginacao && valoresPaginacao.totalPages ? valoresPaginacao.totalPages : 0}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              alwaysShown={false}
            />

          </Col>
          <Col sm={2} className="mt-0 pt-0 pb-0 gap-5 text-center align-middle fs-5 border rounded">
          {valoresPaginacao && valoresPaginacao.totalElements && valoresPaginacao.totalElements > 0 && listaUnitizadorUnidadeDataFiltrada ?
              <React.Fragment>
                <h5 className="pt-1">{`Mostrando ${listaUnitizadorUnidadeDataFiltrada.length} ite${listaUnitizadorUnidadeDataFiltrada.length > 1 ? 'ns' : 'm'} de ${valoresPaginacao.totalElements}.`}</h5>

              </React.Fragment>
              :

              <React.Fragment />

          }
          </Col>
      </Row>

    </>
  )
}

export default ListaUnitizadorUnidadeData